import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { formStyles } from 'consts/styles/Form';
import { useStyles } from './InsideLoaderUseStyles';

const InsideLoader = props => {
  const classes = useStyles(props);
  const formClasses = formStyles();

  const { loaderSize, fontSize, text } = props;
  return (
    <div
      className={`${formClasses.Form}--flex ${formClasses.Form}--flex--center ${classes.InsideLoaderCalc}__modal-container`}
    >
      <CircularProgress
        className={`${formClasses.Form}__switch`}
        size={loaderSize}
      />{' '}
      <Typography
        className={`${formClasses.Form}__text-field ${formClasses.Form}__text-field--small-font`}
        align="center"
        color="primary"
        sx={{ fontSize }}
      >
        &nbsp;&nbsp;{text || ''}
      </Typography>
    </div>
  );
};

InsideLoader.propTypes = {
  loaderSize: PropTypes.number,
  text: PropTypes.string,
  fontSize: PropTypes.number,
};
export default InsideLoader;
